const ALL_TRANSLATIONS: Record<string, string[]> = {
  en: ["All", "all", "ALL"],
  hi: ["सभी", "sabhi", "Sabhi", "SABHI"],
  te: ["అన్నీ", "anni", "Anni", "ANNI"],
  mr: ["सर्व", "sarv", "Sarv", "SARV"],
  ta: ["அனைத்தும்", "anaithum", "Anaithum", "ANAITHUM"],
  kn: ["ಎಲ್ಲಾ", "ella", "Ella", "ELLA"],
  gu: ["બધા", "badha", "Badha", "BADHA"],
  bn: ["সব", "sob", "Sob", "SOB"],
  or: ["ସମସ୍ତ", "samasta", "Samasta", "SAMASTA"],
  pa: ["ਸਾਰੇ", "sare", "Sare", "SARE"],
  ml: ["എല്ലാം", "ellam", "Ellam", "ELLAM"],
};

function getAllPossibleTranslations(): string[] {
  const allVariants: string[] = [];
  Object.values(ALL_TRANSLATIONS).forEach((variants) => {
    allVariants.push(...variants);
  });
  return allVariants;
}

export function getAllTranslation(language: string): string {
  if (!language || typeof language !== "string") {
    return "All";
  }
  const langCode = language.toLowerCase();
  const translations = ALL_TRANSLATIONS[langCode];
  const firstTranslation = translations?.[0];
  return firstTranslation ?? "All";
}

export function isAllCategoryTranslation(categoryName: string, currentLanguage?: string): boolean {
  if (!categoryName || typeof categoryName !== "string") {
    return false;
  }
  const normalized = categoryName.trim().toLowerCase();
  if (currentLanguage && typeof currentLanguage === "string") {
    const langCode = currentLanguage.toLowerCase();
    const translations = ALL_TRANSLATIONS[langCode];
    if (translations) {
      const normalizedTranslations = translations.map((t) => t.toLowerCase().trim());
      if (normalizedTranslations.includes(normalized)) {
        return true;
      }
    }
  }
  const allVariants = getAllPossibleTranslations();
  const normalizedVariants = allVariants.map((t) => t.toLowerCase().trim());
  return normalizedVariants.includes(normalized);
}

export function normalizeAllCategory(categoryName: string, currentLanguage?: string): string {
  if (isAllCategoryTranslation(categoryName, currentLanguage)) {
    return "All";
  }
  return categoryName;
}
